<template>
    <footer>
      <div v-if="currentSong" class="flex imgAndDesc" >
        <img v-if="currentSong.album" class="correctImg" :src="currentSong.album?.cover" alt="">
        <img v-else class="fallbackImg" src="@/assets/foxbel-music-white-icon.png" alt="">
        <div class="songDesc">
          <h4>{{currentSong.title || 'Canción'}}</h4>
          <p>{{currentSong.artist.name || 'Artista'}}</p>
        </div>
      </div>
      <div class="mediaButtons">
        <button class="icon"></button>
        <button class="playPause icon" @click="togglePlay" v-if="playing"></button>
        <button class="playPause" @click="togglePlay" v-else>▶</button>
        <button class="icon"></button>
      </div>
      <div class="audioAndVol">
        <audio v-bind:src="currentSong?.preview" preload="auto" autoplay ref="audioPlayer"/>
        <div class="volume">
          <input type="range" class="volume-range" v-model="volume" />
          <button class="icon" v-if="muted" @click="toggleAudio"></button>
          <button class="icon" v-else @click="toggleAudio"></button>
        </div>
      </div>
    </footer>
</template>

<script>
export default {
    data(){
      return{
        playing: false,
        currentSong: null,
        volume: 100,
        muted: false,
      }
    },
    methods:{     
      togglePlay(){
        if(this.playing){
          this.$refs.audioPlayer.pause();
        } else {
          this.$refs.audioPlayer.play();
        }
        this.playing = !this.playing
      },
      toggleAudio(){
        this.muted = !this.muted
        this.$refs.audioPlayer.muted=this.muted
      },
      localWatcher(){
        setInterval(()=>{
          if(localStorage.getItem('currentSong') && this.currentSong.id!=JSON.parse(localStorage.getItem('currentSong')).id){
            this.currentSong=JSON.parse(localStorage.getItem('currentSong'))
          }
        }, 500)
      },
    },
    watch:{
      currentSong(){
        if(this.$refs.audioPlayer){
          this.$refs.audioPlayer.load()
          this.playing = true
        }
      },
      volume(){
        this.$refs.audioPlayer.volume=this.volume/100
      },
      search(){
        const arturl= this.baseUrl + '/search/artist/?q='+this.search+'&index=0&limit=10&output=json'
        const trackurl= this.baseUrl + '/search/track/?q='+this.search+'&index=0&limit=10&output=json'
        fetch(arturl)
          .then(response=>response.json())
          .then(json=>this.artists = json.data);
        fetch(trackurl)
          .then(response=>response.json())
          .then(json=>this.tracks = json.data);
      }
    },
    created(){
      if(typeof localStorage.getItem('currentSong') !== 'undefined'){
        this.currentSong=JSON.parse(localStorage.getItem('currentSong'))
      }
    },
    beforeMount(){
      this.localWatcher()
    },    
}
</script>

<style>

img{
  width: 250px;
}

footer{
  background-color: #EB5757;
  position: fixed;
  display: grid;
  justify-content: space-between;
  align-items: center;
  bottom: 0;
  width: 100%;
  height: 100px;
}

.routerCont{
  margin: 20px 40px;
  padding-bottom: 120px;
}

footer{
  display: flex;
}
.imgAndDesc{
  display: flex;
  justify-content: center;
}
.correctImg{
  height: 100px;
  width: 100px;
}

.fallbackImg{
  height: 104px;
  width: 125px;
  margin-top: 25px;
  margin-left: 20px;
}

.songDesc{
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 15px;
}

.songDesc>p, h4{
  color: white;
  text-align: start;
  margin: 2px;
}
.mediaButtons{
  display: flex;
  flex-direction: row;
}
.mediaButtons>button{
  height: 50px;
  width: 50px;
  border-radius: 25px;
  border: 0px;
  background-color: transparent;
  color: white;
  cursor: pointer;
}

.icon{
  font-family: 'Font Awesome 6 Free';
  font-weight: 700;
}
.playPause{
  background-color: #FF7676 !important;
}
.playPause:active{
  background-color: #ff76769d !important;
}
.volume{
  display: flex;
  gap: 10px;
  margin-right: 25px;
}
button.icon{
  border: 0;
  font-size: 20px;
  color: white;
  background-color: transparent;
  cursor: pointer;
}
input[type=range] {
  border-radius: 3px;
  -webkit-appearance: none;
  margin: 10px 0;
  width: 100%;
}
input[type=range]:focus {
  outline: none;
}
input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 6px;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 0px 0px 1px #000000;
  background: #FFFFFF;
  border-radius: 4px;
  border: 0px solid #000000;
}
input[type=range]::-webkit-slider-thumb {
  box-shadow: 0px 0px 0px #000000;
  border: 1px solid #F2F2F2;
  height: 24px;
  width: 24px;
  border-radius: 12px;
  background: #FFFFFF;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -9.5px;
}
input[type=range]:focus::-webkit-slider-runnable-track {
  background: #FFFFFF;
}
input[type=range]::-moz-range-track {
  width: 100%;
  height: 6px;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 0px 0px 1px #000000;
  background: #FFFFFF;
  border-radius: 4px;
  border: 0px solid #000000;
}
input[type=range]::-moz-range-thumb {
  box-shadow: 0px 0px 0px #000000;
  border: 1px solid #F2F2F2;
  height: 24px;
  width: 24px;
  border-radius: 12px;
  background: #FFFFFF;
  cursor: pointer;
}
input[type=range]::-ms-track {
  width: 100%;
  height: 6px;
  cursor: pointer;
  animate: 0.2s;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
input[type=range]::-ms-fill-lower {
  background: #FFFFFF;
  border: 0px solid #000000;
  border-radius: 8px;
  box-shadow: 0px 0px 1px #000000;
}
input[type=range]::-ms-fill-upper {
  background: #FFFFFF;
  border: 0px solid #000000;
  border-radius: 8px;
  box-shadow: 0px 0px 1px #000000;
}
input[type=range]::-ms-thumb {
  margin-top: 1px;
  box-shadow: 0px 0px 0px #000000;
  border: 1px solid #F2F2F2;
  height: 24px;
  width: 24px;
  border-radius: 12px;
  background: #FFFFFF;
  cursor: pointer;
}
input[type=range]:focus::-ms-fill-lower {
  background: #FFFFFF;
}
input[type=range]:focus::-ms-fill-upper {
  background: #FFFFFF;
}

@media screen
 and (max-width:500px){
  footer{
    display: grid;
    grid-auto-flow: row;
    grid-template-columns: 60% 40%;
    grid-template-rows: repeat(2,50%);
  }
  .imgAndDesc{
    grid-column-start: 1;
    grid-column-end: 2;
    height: 100%;
  }
  .mediaButtons{
    margin-top: 8px;
    grid-column: 2/2;
    grid-row: 1/2;
  }
  .audioAndVol{
    grid-column: 2/2;
    grid-row: 2/2;
  }
  .volume{
    margin-right: 2px;
  }
  .songDesc{
    justify-content: start;
    margin-top: 8px;
  }
}

</style>